<template>
  <div class="mb-4">
    <div class="flex items-center">
      <label>
        {{ setting.label }}
      </label>

      <button
        v-if="!saving"
        class="change-image-toggle"
        :disabled="disabled || saving"
        @click="onChangeImage"
      >
        {{ changeImageToggle ? "Close" : "Change" }}
      </button>

      <Loader v-if="saving" label="" class="loading-icon" />
    </div>

    <SettingsMessage v-if="setting.message" :message="setting.message" />

    <Uploader
      id="fileUploader"
      :src="setting.fileValue"
      :edit-mode="changeImageToggle"
      :disabled="disabled || saving"
      :inline="inlineUploader"
      :max-file-size="maxFileSize"
      bg-white
      @uploading-complete="onUploadComplete"
      @uploading-failed="$emit('uploading-failed')"
      @uploading-file="$emit('uploading-file')"
      @image-click="onChangeImage"
    />
  </div>
</template>

<script>
import clone from "just-clone";
import Uploader from "@/components/UI/Uploader";
import Loader from "@/components/UI/Loader";
import SettingsMessage from "./SettingsMessage";

export default {
  name: "FileSetting",
  components: { Loader, Uploader, SettingsMessage },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    inlineUploader: {
      default: true,
      type: Boolean
    },
    setting: {
      type: Object,
      required: true,
      id: {
        required: true,
        type: String
      },
      label: {
        type: String
      },
      fileValue: String
    },
    saving: {
      default: false,
      type: Boolean
    },
    maxFileSize: {
      type: Number,
      default: 2.5
    }
  },
  data: () => ({
    changeImageToggle: false
  }),
  methods: {
    onChangeImage() {
      this.changeImageToggle = !this.changeImageToggle;
    },
    onUploadComplete(event) {
      const setting = clone(this.setting);
      setting.fileValue = event;
      this.$emit("setting-updated", setting, event);
      this.$emit("uploading-complete", event);
    }
  }
};
</script>

<style scoped>
.change-image-toggle {
  @apply p-0 m-0 text-brand outline-none ml-auto mb-4;
  font-size: 14px;
  line-height: 1;
  vertical-align: text-top;

  &:hover {
    @apply underline;
  }
}

.loading-icon {
  @apply ml-auto p-0;
  font-size: 0.6rem;
  margin-right: 15px;
}
</style>
